var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17007 6.16928C6.37621 5.96409 6.69879 5.94544 6.9261 6.11332L6.99122 6.16928L12 11.1545L17.0088 6.16928C17.2149 5.96409 17.5375 5.94544 17.7648 6.11332L17.8299 6.16928C18.0361 6.37446 18.0548 6.69554 17.8862 6.9218L17.8299 6.98662L12.4106 12.3808C12.2044 12.586 11.8819 12.6047 11.6545 12.4368L11.5894 12.3808L6.17007 6.98662C5.94331 6.76092 5.94331 6.39498 6.17007 6.16928Z",
    fill: "#FF0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8299 17.8307C17.6238 18.0359 17.3012 18.0546 17.0739 17.8867L17.0088 17.8307L12 12.8455L6.99122 17.8307C6.78508 18.0359 6.4625 18.0546 6.23519 17.8867L6.17007 17.8307C5.96393 17.6255 5.94519 17.3045 6.11385 17.0782L6.17007 17.0134L11.5894 11.6192C11.7956 11.414 12.1181 11.3953 12.3455 11.5632L12.4106 11.6192L17.8299 17.0134C18.0567 17.2391 18.0567 17.605 17.8299 17.8307Z",
    fill: "#FF0909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRed);
export default __webpack_public_path__ + "static/media/icon-close-red.98cf8b85f60737158dbdabd52aae53f5.svg";
export { ForwardRef as ReactComponent };